import { render, staticRenderFns } from "./PersonalContactListItem.vue?vue&type=template&id=def58600&scoped=true&"
import script from "./PersonalContactListItem.vue?vue&type=script&lang=ts&"
export * from "./PersonalContactListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalContactListItem.vue?vue&type=style&index=0&id=def58600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def58600",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent})
